import { useEffect } from "react";
import { withAuthProvider } from "../auth";
import { initTrackingContext, initTracking } from "./tracking";
import { isBot } from "../Analytics/botDetection";

function extractUserTraits(me) {
  return {
    id: me ? me.id || null : null,
    primaryEmail: me ? me.primaryEmail || null : null,
    type: me ? me.type || null : null,
    firstName: me ? me.firstName || null : null,
    lastName: me ? me.lastName || null : null,
    displayName: me ? me.displayName || null : null,
    role: me ? me.role || null : null,
    class: me ? me.class || null : null,
  };
}

const runIdentifyIfTraitsChanged = (me) => {
  if (!me.externalId && !me.id) return false;

  const traits = extractUserTraits(me);
  const storedTraits = JSON.parse(
    localStorage.getItem("last_identified_traits") || "{}",
  );

  const traitsChanged = JSON.stringify(traits) !== JSON.stringify(storedTraits);

  if (traitsChanged) {
    localStorage.setItem("last_identified_traits", JSON.stringify(traits));
  }

  return traitsChanged;
};

const SegmentWrapper = ({ isLoggedIn, me }) => {
  useEffect(() => {
    if (isBot()) {
      return;
    }

    if (typeof window === "undefined" || !window.analytics) return;
    const initTimeout = setTimeout(() => {
      try {
        const userId = me ? me.externalId || me.id : null;
        if (isLoggedIn && userId) {
          const previousUserId = sessionStorage.getItem("segment_userId");
          if (runIdentifyIfTraitsChanged(me) || previousUserId !== userId) {
            window.analytics.identify(userId, {
              ...me,
            });
            sessionStorage.setItem("segment_userId", userId);
            localStorage.setItem(
              "last_identified_traits",
              JSON.stringify(extractUserTraits(me)),
            );
          }
        } else if (!isLoggedIn && !userId) {
          sessionStorage.setItem("segment_userId", "anonymous");
          localStorage.setItem("last_identified_traits", JSON.stringify("{}"));
          window.analytics.reset();
        }

        initTrackingContext({
          user: isLoggedIn && me ? { id: userId, ...me } : null,
          isLoggedIn,
        });

        initTracking();
      } catch (error) {
        console.error("Error initializing tracking:", error);
      }
    }, 3000); // 3 second delay (login)

    return () => {
      clearTimeout(initTimeout);
    };
  }, [isLoggedIn, me]);

  return null;
};

export default withAuthProvider(SegmentWrapper);
